// Inline SVG icon components matching Lucide style
// stroke="currentColor", stroke-width="1.5", fill="none", stroke-linecap="round", stroke-linejoin="round"

const baseAttrs = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "1.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
};

function icon(paths, name) {
  return {
    name,
    functional: true,
    props: {
      size: { type: [Number, String], default: 16 },
      color: { type: String, default: undefined }
    },
    render(h, { props }) {
      const s = Number(props.size);
      return h(
        "svg",
        {
          attrs: {
            ...baseAttrs,
            width: s,
            height: s,
            viewBox: "0 0 24 24"
          },
          style: props.color ? { color: props.color } : undefined
        },
        paths.map(p =>
          typeof p === "string"
            ? h("path", { attrs: { d: p } })
            : h(p.tag, { attrs: p.attrs })
        )
      );
    }
  };
}

// X (close)
export const XIcon = icon(["M18 6 6 18", "m6 6 12 12"], "XIcon");

// User
export const UserIcon = icon(
  [
    "M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2",
    { tag: "circle", attrs: { cx: "12", cy: "7", r: "4" } }
  ],
  "UserIcon"
);

// Users
export const UsersIcon = icon(
  [
    "M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2",
    { tag: "circle", attrs: { cx: "9", cy: "7", r: "4" } },
    "M22 21v-2a4 4 0 0 0-3-3.87",
    "M16 3.13a4 4 0 0 1 0 7.75"
  ],
  "UsersIcon"
);

// Plus
export const PlusIcon = icon(["M5 12h14", "M12 5v14"], "PlusIcon");

// Edit2 (pencil)
export const Edit2Icon = icon(
  ["M17 3a2.85 2.83 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5Z", "m15 5 4 4"],
  "Edit2Icon"
);

// Trash2
export const Trash2Icon = icon(
  [
    "M3 6h18",
    "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6",
    "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2",
    "M10 11v6",
    "M14 11v6"
  ],
  "Trash2Icon"
);

// Mail
export const MailIcon = icon(
  [
    {
      tag: "rect",
      attrs: { width: "20", height: "16", x: "2", y: "4", rx: "2" }
    },
    "m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"
  ],
  "MailIcon"
);

// Image
export const ImageIcon = icon(
  [
    {
      tag: "rect",
      attrs: { width: "18", height: "18", x: "3", y: "3", rx: "2", ry: "2" }
    },
    { tag: "circle", attrs: { cx: "9", cy: "9", r: "2" } },
    "m21 15-3.086-3.086a2 2 0 0 0-2.828 0L6 21"
  ],
  "ImageIcon"
);

// ArrowLeft
export const ArrowLeftIcon = icon(
  ["m12 19-7-7 7-7", "M19 12H5"],
  "ArrowLeftIcon"
);

// ChevronRight
export const ChevronRightIcon = icon(["m9 18 6-6-6-6"], "ChevronRightIcon");

// Search
export const SearchIcon = icon(
  [{ tag: "circle", attrs: { cx: "11", cy: "11", r: "8" } }, "m21 21-4.3-4.3"],
  "SearchIcon"
);
